import { render, staticRenderFns } from "./hqglMailSendInfo.vue?vue&type=template&id=79445176&scoped=true&"
import script from "./hqglMailSendInfo.vue?vue&type=script&lang=js&"
export * from "./hqglMailSendInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79445176",
  null
  
)

export default component.exports